const WarehouseList = () => import('Views/warehouse/warehouse-list');
const WarehouseAddEdit = () => import('Views/warehouse/warehouse-addEdit');
const WarehouseDetail = () => import('Views/warehouse/warehouse-detail');

export default[
  { path: '/warehouse-list', component: WarehouseList },
  { path: '/warehouse-add', component: WarehouseAddEdit },
  { path: '/warehouse-edit/:id', component: WarehouseAddEdit },
  { path: '/warehouse-detail/:id', component: WarehouseDetail },
];



// WEBPACK FOOTER //
// ./src/router/warehouse.js